import { Injectable } from '@angular/core';
import { CustomHttpService } from '@services/generals/custom-http.service';
import { AbstractService } from "@services/abstract.service";
import { UserRolClass } from '@classes/user-rol.class';

@Injectable({providedIn: 'root'})
export class UserRolService extends AbstractService {
    constructor(
        public customHttpService: CustomHttpService,
    ) {
        super(customHttpService, new UserRolClass());
        this.version = 'v1';
    }
}
